import '../lib/readmore-fixed';
import Aos from 'aos';

$(function () {
    // if (screen.width < 767) {
    //     $('.rw-desciption--content').readmore({
    //         embedCSS: true,
    //         moreLink: '<a href="#" class="btn btn--primary mt-4"><div class="btn__arrow"><i class="icon icon-arrow-right"></i></div>Meer filters</a>',
    //         lessLink: '<a href="#" class="btn--secondary mt-5" onclick="window.scrollTo(\'.rw-desciption--contente\')">Minder filters</a>',
    //         collapsedHeight: 400,
    //     });
    // }
    $('.rw-description--content').readmore({
        embedCSS: true,
        moreLink: '<div class="post-item__link" data-aos="fade-right" data-aos-anchor-placement="top-bottom" data-aos-delay="200"><i class="icon icon-arrow-right"></i>Lees meer</div>',
        lessLink: '<div class="post-item__link" onclick="window.scrollTo(\'.rw-description--content\')"><i class="icon icon-arrow-right"></i>Lees minder</div>',
        collapsedHeight: 400,
        beforeToggle: function() {
            $('.rw-description--content').toggleClass('active-readmore');
        },
        blockProcessed: function() {
            Aos.refresh();
        },
    });
    $('.rw-description--features').readmore({
        embedCSS: true,
        moreLink: '<div class="post-item__link" data-aos="fade-right" data-aos-anchor-placement="top-bottom" data-aos-delay="500"><i class="icon icon-arrow-right"></i>Lees meer</div>',
        lessLink: '<div class="post-item__link" onclick="window.scrollTo(\'.rw-description--features\')"><i class="icon icon-arrow-right"></i>Lees minder</div>',
        collapsedHeight: 400,
        beforeToggle: function() {
            $('.rw-description--features').toggleClass('active-readmore');
        },
        blockProcessed: function() {
            Aos.refresh();
        },
    });
});
